import {
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Menu,
  Modal,
  OutlinedInput,
  Pagination,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import BasicLayout from "../layout/BasicLayout";
import { useEffect, useState } from "react";

import useDebounce from "../hooks/trainingHooks/useDebounce";
import useFetchTrainings from "../hooks/trainingHooks/useFetchTrainings";
import {
  getTrainingPageFilters,
  pageLimit,
  sortingSystem,
  UserRole,
} from "../utils/consts";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useTRSIIOptIn from "../hooks/trainingHooks/useTRSIIOptIn";
import useFetchServicers from "../hooks/trainingHooks/useFetchServicers";
import ServicerTableForApprover from "../components/ServicerOptOutPage/servicerTable/ServicerTableForApprover";
import ServicerTableForAdmin from "../components/ServicerOptOutPage/servicerTable/ServicerTableForAdmin";
import { useSelector } from "react-redux";


const ServicerOptOutPage = () => {
  // 1 - sort by training created time
  // 2 - sort by training name

  const [order, setOrder] = useState('DESC')
  const [orderBy, setOrderBy] = useState('Submitted Date')
  //const [sortBy, setSortBy] = useState(
  //  sortingSystem.servicerMaintenancePage.defaultSortValue
  //);
  const [searchKeyword, setSearchKeyword] = useState("");
  
  const debouncedSearchKeyword = useDebounce(searchKeyword, 500);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(pageLimit);

  const [fileType, setFileType] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const { email, userName, userRole, servicerId, servicerMasterName, trsiiOptIn, optOutFlag } =
  useSelector((state) => state.user);

  const { isLoading, data, error, isError, isFetching } = useFetchServicers(
  //const { isLoad, serData, erro, isErro, isFetchin } = useFetchServicers(
    ["getAllOptOutServicers", debouncedSearchKeyword, order, orderBy, page, limit],
    page,
    limit,
    debouncedSearchKeyword,
    order,
    orderBy
  );

  useEffect(() => {
    setPage(1);
  }, [debouncedSearchKeyword]);

  const renderServicerTable = (userRole) => {
    if ((userRole.toUpperCase() === UserRole.APPROVER) && data) {
      return <ServicerTableForApprover servicerList={data.servicerList} userRole={userRole} />;
  }
  if ((userRole.toUpperCase() === UserRole.ADMIN) && data) {
    return <ServicerTableForAdmin servicerList={data.servicerList} userRole={userRole} />;
}
};


  return (
    <BasicLayout>
      <Box display="flex" justifyContent="center" width="100%" marginBottom={5}>
        <Typography variant="h4">
          List of Servicers that have Opted Out of Public Scoring{" "}
        </Typography>
      </Box>
      <Container maxWidth="xl">
        <Box sx={{ minHeight: "390px", minWidth: "600px" }}>
          {data && renderServicerTable(userRole)}
        </Box>
        {data && (
          <Pagination
            sx={{ mt: 2 }}
            count={data.totalPage}
            page={page}
            onChange={(_e, v) => setPage(v)}
          />
        )}
      </Container>
      <Box marginBottom={5}></Box>
    </BasicLayout>
  );
};


export default ServicerOptOutPage;
